<template>
  <!-- echarts -->
  <div style="width:100%;height:235px" v-bind:id="id" v-bind:data="data"></div>
</template>

<script>
let unwatch, myChart
export default {
  name: 'MonitoringCurveEchart',
  props: {
    id: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ChartLineGraph: null
    }
  },
  // watch: {
  //   data: {
  //     deep: true,
  //     handler(newvalue, oldvalue) {
  //       console.log('ss')
  //       this.drawLineGraph(this.id, newvalue)
  //     },
  //     immediate: true
  //   }
  // },
  mounted() {
    this.drawLineGraph(this.id)
  },
  created() {},
  methods: {
    drawLineGraph(id) {
      let _this = this
      myChart = echarts.init(document.getElementById(id))
      unwatch = this.$watch(
        'data',
        function(newvalue, oldvalue) {
          if (newvalue) {
            this.set(newvalue)
          }
        },
        { deep: true, immediate: true }
      )
    },
    set(data) {
      myChart.setOption(data)
      window.addEventListener('resize', function() {
        myChart.resize()
      })
    }
  },
  beforeDestroy() {
    // if (this.ChartLineGraph) {
    //   this.ChartLineGraph.clear()
    // }
    // if (unwatch) {
    //   unwatch()
    //   unwatch = null
    // }
    // if (!myChart?.isDisposed) {
    //   myChart.dispose()
    // }
  }
}
</script>

<style lang="less" scoped>
</style>
